import { AnyObject } from "./generic";

export type RequestInput = {
  method: string;
  path?: string;
  query?: any;
  data?: any;
  url?: string;
  xhrEvents?: any;
  signal?: AbortSignal;
};

export interface DetailedRequest extends Request {
  rows?: any;
  lastRow: number | undefined;
}

/*
 * The presigned post field body.
 * These fields grant bucket authorisation when attached to an S3 request.
 * The Service API is responsible for correctly forming this body.
 */
export type PresignedPostFields = {
  AWSAccessKeyId: string;
  "Content-Type": string;
  acl: "private";
  key: string;
  policy: string;
  signature: string;
};

/**
 * Response from the backend when a request is successful.
 */
export type OkResponse = {
  Message: "OK";
};

export type BasePagination = {
  /**
   * The maximum number of items to return.
   */
  Limit?: number;
  /**
   * The index from the total result set to start returning items.
   */
  Start: number;
};

/**
 * Pagination requests pass along a limit and start
 */
export type RequestPagination = BasePagination;

export type ResponsePagination = BasePagination & {
  /**
   * The total number of items in the result set. This may be smaller than the number of items requested
   * as it is capped by the total number of items in the result set for the current page.
   */
  Total: number;
};

export type PaginatedRequest<T> = T & {
  /**
   * The pagination parameters for the request.
   */
  Pagination: RequestPagination;
};

export type PaginatedResponse<T> = T & {
  /**
   * The pagination parameters for the response.
   */
  Pagination: ResponsePagination;
};

export type ErrorResponse = {
  status: number;
  data: {
    code: string; // this may be an empty string, but should always be present
    message: string;
  };
};

export const isErrorResponse = (obj: unknown): obj is ErrorResponse => {
  if (obj && typeof obj === "object" && "status" in obj && "data" in obj) {
    const { data } = obj as AnyObject;
    if (data && typeof data === "object" && "code" in data && "message" in data) {
      return true;
    }
  }
  return false;
};
